import {
  AfterViewInit,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
  ViewChild,
} from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
  FormsModule,
  ReactiveFormsModule,
} from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { NgClass } from '@angular/common';

@Component({
  selector: 'app-search-bar',
  templateUrl: './search-bar.component.html',
  styleUrls: ['./search-bar.component.scss'],
  standalone: true,
  imports: [NgClass, FormsModule, ReactiveFormsModule, TranslateModule],
})
export class SearchBarComponent implements OnChanges, AfterViewInit {
  @Input() typedTerm: string;
  @Output() typedTermChange: EventEmitter<string>;
  @Input() isSubmitted: boolean;
  @Output() searchTerm: EventEmitter<string>;
  @Input() isDisabled: boolean;

  @ViewChild('searchArea') searchArea: ElementRef;

  searchForm: FormGroup;
  displaySearchError: boolean;

  constructor(private fb: FormBuilder) {
    this.typedTerm = '';
    this.typedTermChange = new EventEmitter<string>();
    this.isSubmitted = false;
    this.searchTerm = new EventEmitter<string>();
    this.isDisabled = false;
    this.searchForm = this.fb.group({
      term: new FormControl(
        { value: this.typedTerm, disabled: this.isDisabled },
        [Validators.required, Validators.minLength(1)]
      ),
    });
    this.displaySearchError = false;
  }

  ngAfterViewInit() {
    this.searchArea.nativeElement.focus({ preventScroll: true });
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.typedTerm) {
      this.searchForm.patchValue({ term: this.typedTerm });
    }
    if (changes.isSubmitted?.currentValue) {
      this.onSearch();
    }
    if (!!changes.isDisabled) {
      if (changes.isDisabled.currentValue) {
        this.searchForm.controls.term.disable();
      } else {
        this.searchForm.controls.term.enable();
      }
    }
  }

  onSearch(): void {
    if (this.searchForm.valid) {
      this.searchTerm.emit(this.searchForm.controls['term'].value);
    } else {
      if (!this.displaySearchError) {
        this.displaySearchError = true;
        setTimeout(() => {
          this.displaySearchError = false;
        }, 3000);
      }
    }
  }

  onChangeSearchTerm(term: string): void {
    this.typedTermChange.next(term);
  }
}
